// Create a react component that displays recently viewed products from the API. Use ProductList and ProductList Item components.

import React, { useEffect, useState } from 'react';
import ProductList from './ProductList';
import { bool } from 'prop-types';
import { useLocation } from 'react-router-dom';

const MAX_PRODUCT_VIEWED = 25;

const RecentlyViewedProducts = ({ isMobile }) => {
    const [products, setProducts] = useState([]);
    const location = useLocation();
    
    // Fetch the recently viewed products from the API
    // When the location changes
    useEffect(() => {
        // Get the recently viewed products from the local storage
        // eslint-disable-next-line no-undef
        const productIds = localStorage.getItem('recentlyViewedProducts');
        if (!productIds) {
            return;
        }
        const params = new URLSearchParams({
            // eslint-disable-next-line no-undef
            productIds,
            limit: MAX_PRODUCT_VIEWED,
            page: 0,
        }).toString();
        // Fetch the recently viewed products from the API
        fetch(new URL(`/api/products/?${params}`, process.env.APP_URL))
            .then((response) => response.json())
            .then((data) => setProducts(data?.products || []));
    }, [location.pathname]);

    if (!products || !products.length) {
        return null;
    }
    
    return (
        <div
            className={'mt-3 mb-3'}
            style={{
                maxWidth: '1400px',
                marginLeft: 'auto',
                marginRight: 'auto',
            }}>
            <h3
                className={'ms-sm-2 ms-md-0'}>Your Browsing History</h3>
            <p
                className={'ms-sm-2 ms-md-0'}>These items were viewed recently.</p>
            <ProductList
                isMobile={isMobile}
                featured={false}
                minimized={true}
                products={products}
                historyMode={true}
                alignLeft={true}>
            </ProductList>
        </div>
    );
};

RecentlyViewedProducts.displayName = 'RecentlyViewedProducts';
RecentlyViewedProducts.propTypes = {
    isMobile: bool.isRequired,
};

export default RecentlyViewedProducts;